<template>

    <main id="searchWrapper" class="d-none">

        <a href="javascript:" class="close" onclick="openSearch()"><i class="fal fa-times"></i></a>

        <div class="form-wrapper">

            <form action="/search" method="get">
                <div class="form-row align-items-center">

                    <div class="col">
                        <label class="sr-only" for="inlineFormInputGroup">Iskanje</label>
                        <div class="input-group">
                            <input type="text" required class="form-control" id="inlineFormInputGroup" name="search" placeholder="Iskanje ...">
                            <button type="submit" class="btn btn-danger"><i class="fal fa-search"></i> &nbsp; Išči</button>
                        </div>
                    </div>
                </div>
            </form>

        </div>

    </main>

</template>

<script>

    export default {
        data() {
            return {
            }
        }
    }
</script>

<style lang="scss">


</style>



// WEBPACK FOOTER //
// src/layout/Search.vue